import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import BadShipmentsList from '../../components/system/BadShipments/BadShipmentsList';
import BadShipmentsHeader from '../../components/system/BadShipments/BadShipmentsHeader';

import { useSessionContext } from '../../contexts/SessionContext';

export default function BadShipmentsPage( props ){
    //console.debug("RTS Break BadShipmentsPage");

    const {curFilter, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    //const [filter, setFilter] = useState(null);
    const [data, setData] = useState([]);

    const fetchData = useCallback(() => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Loads/GetBadShipments";
        axios
        .post(
            apiURL,
            {},
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        // if(curFilter != null && curFilter.key === 'ReelTypesPage'){
        //     setFilter(curFilter.filter);
        //     fetchData(curFilter.filter);
        // }
        // else{
            // setFilter({material:'Steel', status:-1, sortBy:0});
            fetchData();
        // }
    }, [props, curFilter, fetchData]); 

    
    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box id="pageBox">
            <BadShipmentsHeader />
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <BadShipmentsList data={data} />
            </Box>
        </Box>
    );
}
